// eslint-disable-next-line no-restricted-imports
import { IconButton as ArcIconButton } from 'arc';
import { ReactElement, forwardRef, ForwardedRef, ComponentProps } from 'react';
import { useInputSizeForApplicationType } from '../common/hooks/use-input-size-for-application-type';

export const IconButton = forwardRef(function IconButton(
    props: ComponentProps<typeof ArcIconButton>,
    ref: ForwardedRef<HTMLButtonElement>
): ReactElement {
    const { size: propsSize, ...otherProps } = props;
    const size = useInputSizeForApplicationType(propsSize, { frSizeOverride: 'lg' });
    return <ArcIconButton ref={ref} size={size} {...otherProps} />;
});
